import React from 'react';
import { invitationLabs } from '../assets';
import { FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-charcoal text-cream py-10 px-8 text-center">
      <div className="max-w-2xl mx-auto space-y-4">
        <p className="font-display text-xl italic opacity-90">
          Together is a beautiful place to be
        </p>

        <div className="logo max-w-32  w-full overflow-hidden mx-auto object-center">
          <img src={invitationLabs} className='w-full block object-center' alt="invitation labs logo" />
        </div>

        <div className="flex justify-center">
          <a href="https://www.instagram.com/theinvitationlabs/" target='_blank' rel='noreferrer'>
            <FaInstagram className='w-4 h-4' />
          </a>
        </div>

        <div className="w-16 h-px bg-gold opacity-50 mx-auto" />


        <p className="text-sm opacity-60 tracking-wider">
          © 2026 Wedding Invitation. Made with ♥ from Alyssa & Caleb
        </p>
      </div>
    </footer>
  );
};

export default Footer;
